import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormArray, FormGroup} from '@angular/forms';
import {VSensorService} from './v-sensor-shared/v-sensor.service';
import {faInfoCircle, faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-v-sensor',
    templateUrl: './v-sensor.component.html',
    styleUrls: ['./v-sensor.component.css']
})
export class VSensorComponent implements OnInit, OnDestroy {

    @Input() readOnly = false;
    @Input() deviceUid;
    @Input() associatedLocationId;
    @Input() associatedProjectId;
    @Input() deviceParams: FormGroup;
    formChangesInProcess = false;
    faInfoCircle = faInfoCircle;
    faPlusCircle = faPlusCircle;
    private _deviceParamsValueChangesSubsc: Subscription;

    // To avoid typing issues on template side
    get deviceParamsLocationControls(): AbstractControl[] | undefined {
        return this.deviceParams ? (<FormArray>this.deviceParams.get('locations')).controls : undefined;
    }

    // In readOnly case - to keep a reference to the initial input value
    private _deviceParams: FormGroup;

    constructor(protected vSensorService: VSensorService,
                protected changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (!this.associatedLocationId || !this.associatedProjectId) { return; }
        this.vSensorService.fetchAndStoreProjectLocations(this.associatedProjectId, this.associatedLocationId);
        // Angular does not update forms which are passed to components as input
        // Careful: only on non-editable component instances, otherwise will lead to 'excessive call stack' error
        if (this.readOnly) {
          this._deviceParams = this.deviceParams;
          this.deviceParams = this.vSensorService.VSensorParamFormFactory(this.deviceParams.value, true);
          this._deviceParamsValueChangesSubsc = this._deviceParams.valueChanges.subscribe(
              (value) => this.deviceParams = this.vSensorService.VSensorParamFormFactory(value, true)
          );
        }
    }

    ngOnDestroy() {
        this.vSensorService.resetProjectLocations();
        if (this._deviceParamsValueChangesSubsc) {
            this._deviceParamsValueChangesSubsc.unsubscribe();
        }
    }

    addLocationControl() {
        (<FormArray>this.deviceParams.get('locations')).push(this.vSensorService.locationControlFactory());
    }

    deleteLocationControl(controlIndex) {
        this.formChangesInProcess = true;
        this.changeDetectorRef.detectChanges();
        (<FormArray>this.deviceParams.get('locations')).removeAt(controlIndex);
        this.formChangesInProcess = false;
    }

}
